module.exports = __webpack_public_path__ + "static/media/AvenirBook.6b414da3.ttf";